var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-result',{attrs:{"status":"404","title":"404","sub-title":"Sorry, the page you visited does not exist."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }